import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useConfirmConsentScreen() {
  return useMutation(trpcOptions.app.confirmConsentScreen.mutationOptions())
}
